

if(typeof(SearchJS) == "undefined" || SearchJS == null || !SearchJS){

	SearchJS = {

		autoSuggestTimer: -1,

		autoSuggestKeystrokeDelay : 400,

		autoSuggestHover : false,

		autoSuggestPreviousTerm : "",

		autoSuggestURL : "",

		autoSelectOption : -1,

		historyIndex : -1,

		retrievedCachedSuggestions : false,

		TOTAL_SUGGESTED : 4,

		TOTAL_HISTORY : 2,

		AUTOSUGGEST_THRESHOLD : 2,

		DYNAMIC_AUTOSUGGEST_THRESHOLD : 1,

		CACHED_AUTOSUGGEST_OFFSET : 1000,

		END_OF_LIST : false,
		STATIC_CONTENT_SECTION_DIV: ["autoSuggestStatic_1", "autoSuggestStatic_2", "autoSuggestStatic_3"],


		staticContentHeaderHistory:"",

		CachedSuggestionsURL:"",

		SearchAutoSuggestServletURL:"",

		searchDepartmentHoverTimeout:"",
		searchSuggestionHoverTimeout:"",

		searchDepartmentSelect: function(categoryId, lel){
			byId('searchDepartmentLabel').innerHTML=lel.innerHTML;
			byId('search_categoryId').value = categoryId;
			this.hideSearchDepartmentList();
			return false;
		},

		cancelEvent: function(e) {
			if (e.stopPropagation) {
				e.stopPropagation();
			}
			if (e.preventDefault) {
				e.preventDefault();
			}
			e.cancelBubble = true;
			e.cancel = true;
			e.returnValue = false;
		},

		searchDepartmentKeyPressed: function(event, pos, size, categoryId, item){
			if (event.keyCode == 13) { 
				this.searchDepartmentSelect(categoryId, item);
				var scrElement = document.getElementById("mobileSearchDropdown");
				if (scrElement != null && scrElement.style.display == 'block'){
					dojo.byId("MobileSimpleSearchForm_SearchTerm").focus();
				}else{
					document.CatalogSearchForm.searchTerm.focus();
				}
			} else if (event.keyCode == 38) { 
				if (pos != 0) {
					dojo.byId('searchDepartmentList_' + (pos - 1)).focus();
					this.cancelEvent(event);
				}
			} else if (event.keyCode == 40) { 
				if (pos != size) {
					dojo.byId('searchDepartmentList_' + (pos + 1)).focus();
					this.cancelEvent(event);
				}
			} else if (event.keyCode == 27) { 
				var scrElement = document.getElementById("mobileSearchDropdown");
				if (scrElement != null && scrElement.style.display == 'block'){
					dojo.byId("MobileSimpleSearchForm_SearchTerm").focus();
				}else{
					document.CatalogSearchForm.searchTerm.focus();
				}
				this.hideSearchDepartmentList();
			} else if (event.shiftKey && event.keyCode == 9) { 
				var scrElement = document.getElementById("mobileSearchDropdown");
				if (scrElement != null && scrElement.style.display == 'block'){
					dojo.byId("MobileSimpleSearchForm_SearchTerm").focus();
				}else{
					document.CatalogSearchForm.searchTerm.focus();
				}
				this.cancelEvent(event);
				this.hideSearchDepartmentList();
			} else if (event.keyCode == 9) { 
				dojo.byId('search_submit').focus();
				this.cancelEvent(event);
				this.hideSearchDepartmentList();
			}

			return false;
		},

		hideSearchDepartmentList: function(){
			byId('searchDepartmentList').style.display="none";
		},

		init:function(){
			dojo.connect(document.CatalogSearchForm.searchTerm, "onfocus", SearchJS, SearchJS._onFocus);
			dojo.connect(document.CatalogSearchForm.searchTerm, "onblur", SearchJS, SearchJS._onBlur);
			dojo.connect(document.CatalogSearchForm.searchTerm, "onkeyup", SearchJS, SearchJS._onKeyUp);

			this.staticContentHeaderHistory = storeNLS["HISTORY"];
		},

		showSearchComponent:function(){
			var srcElement = document.getElementById("searchDropdown");
			if(srcElement != null) {
				srcElement.style.display= 'block';
			}
		  },

		hideSearchComponent:function(){
			var srcElement = document.getElementById("searchDropdown");
			if(srcElement != null) {
				srcElement.style.display= 'none';
			}
			document.getElementById("look-ahead").classList.hide("active");
		},

		_showMobileSearchComponent:function(){
			var srcElement = document.getElementById("mobileSearchDropdown");
			if(srcElement != null) {
			  if(srcElement.style.display == "block") {
				  DepartmentJS.close('mobileSearchDropdown');
				srcElement.style.display= 'none';
			  }
			  else
			  {
				dojo.query(".subDeptDropdown ").forEach(function(node){
					DepartmentJS.close(node.id);
				});
				DepartmentJS.close("departmentsDropdown");
				srcElement.style.display='block';
			  }
			}
		  },

		setCachedSuggestionsURL:function(url){
			this.CachedSuggestionsURL = getAbsoluteURL() + url;
		},

		setAutoSuggestURL:function(url){
			this.SearchAutoSuggestServletURL = getAbsoluteURL() + url;
		},

		_onFocus:function(evt){
			this.showSearchComponent();
			this.retrieveCachedSuggestions();
		},

		_MobileonFocus:function(evt){
			this.showSearchComponent();
			this.retrieveCachedSuggestions();
		},

		_onBlur:function(evt){
			clearTimeout(this.searchSuggestionHoverTimeout);
			this.searchSuggestionHoverTimeout = setTimeout("SearchJS.showAutoSuggest(false)",250);
		},

		_MobileonBlur:function(evt){
			clearTimeout(this.searchSuggestionHoverTimeout);
			this.searchSuggestionHoverTimeout = setTimeout("SearchJS.showAutoSuggest(false)",100);
		},

		_onKeyPress:function(evt){
			return evt.keyCode != dojo.keys.ENTER;
		},

		_onKeyUp:function(evt){
			var srcElement = document.getElementById("searchDropdown");
			srcElement.style.display='block';
			this.doAutoSuggest(evt, this.SearchAutoSuggestServletURL, document.CatalogSearchForm.searchTerm.value);
		},
		_MobileonKeyUp:function(evt){
			var srcElement = document.getElementById("mobileSearchDropdown");
			srcElement.style.display='block';
			this.doAutoSuggest(evt, this.SearchAutoSuggestServletURL, dojo.byId("MobileSimpleSearchForm_SearchTerm").value);
		},

		_handleEnterKey:function() {
			document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
			if(document.CatalogSearchForm.searchTerm.value.length > 0) {
				if(this.END_OF_LIST) {
					this.gotoAdvancedSearch(byId("advancedSearch").href);
				}
				else if(this.autoSuggestURL != "") {
					document.location.href = this.autoSuggestURL;
				}
				else {
					document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
					submitSpecifiedForm(document.CatalogSearchForm);
				}
			}

		},


		_onClick:function(evt){
			document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
			if(document.CatalogSearchForm.searchTerm.value.length > 0) {
				submitSpecifiedForm(document.CatalogSearchForm);
			}
			return false;
		},

		_MobileonClick:function(evt){
			document.MobileCatalogSearchForm.searchTerm.value = trim(document.MobileCatalogSearchForm.searchTerm.value);
			if(document.MobileCatalogSearchForm.searchTerm.value.length > 0) {
				submitSpecifiedForm(document.MobileCatalogSearchForm);
			}
			return false;
		},

		doDynamicAutoSuggest:function(url, searchTerm, showHeader) {
			if(this.autoSuggestTimer != -1) {
				clearTimeout(this.autoSuggestTimer);
				this.autoSuggestTimer = -1;
			};

			this.autoSuggestTimer = setTimeout(function() {

								if($(".look-ahead-categories .list_section").length > 0){
					$("#look-ahead").addClass("active");
				}else{
					$("#look-ahead").removeClass("active");
				}

								var lowerCaseSearchTerm = searchTerm.toLowerCase();
			 	$.ajax({
			 		url : url + "&term=" + encodeURIComponent(searchTerm) + "&showHeader=" + showHeader,
			 		type : 'GET',
			 		 cache: false,
			 		contentType: 'application/json',
			 		dataType: 'json',
			 		data: '',
			 		success: function(data){
			 			var isDataExistrs=false;
			 			var htmlliSuggestionContent = "";
			 			var htmlContent = "";
			 			var searchHeader = data.SearchTermResult.header;
			 			for(var i in data.SearchTermResult.results){
			 				isDataExistrs=true;
			 				htmlliSuggestionContent = htmlliSuggestionContent+"<li id='suggestionItem_"+i+"' role='listitem' tabindex='-1'>";
			 				htmlliSuggestionContent = htmlliSuggestionContent+"<a role='listitem' href='#' onmouseout='this.className=\"\"' "
			 				htmlliSuggestionContent = htmlliSuggestionContent+" onmouseover='SearchJS.enableAutoSelect(\""+i+"\");'  ";
			 				htmlliSuggestionContent = htmlliSuggestionContent+" onclick='SearchJS.selectAutoSuggest(this.title); return false;' title='"+data.SearchTermResult.results[i]+"'";
			 				htmlliSuggestionContent = htmlliSuggestionContent+" id='autoSelectOption_"+i+"'>"
			 				htmlliSuggestionContent = htmlliSuggestionContent+ data.SearchTermResult.results[i].replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
							htmlliSuggestionContent = htmlliSuggestionContent+'</a></li>';
			 			}
			 			if(isDataExistrs){
			 				htmlContent = "<div id='suggestedKeywordResults'><div id='look-ahead-keywords'>"+searchHeader;
			 				htmlContent = htmlContent+"<div class='list_section'>";
			 				htmlContent = htmlContent+"<div title='"+searchHeader+"' role='list' aria-labelledby='suggest_keywords_ACCE_Label'></div>";
			 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
			 				htmlContent = htmlContent+htmlliSuggestionContent;
			 				htmlContent = htmlContent+"</ul></div></div></div>";
			 				$("#searchSuggestionResults_div").html(htmlContent);

			 							 			}
			 			var productHeader="";
			 			if(typeof(data) != "undefined" && typeof(data.ProductResults) != "undefined" && typeof(data.ProductResults.header) != "undefined"){
			 				productHeader = data.ProductResults.header
			 			}

			 						 			var htmlContentProduct = "<div class='row'>";
			 			htmlContentProduct = htmlContentProduct+"<div class='col-12'>"+productHeader+"</div></div>";
			 			htmlContentProduct = htmlContentProduct+"<div class='row'>";
			 		if(typeof(data) != "undefined" && typeof(data.ProductResults) != "undefined" && typeof(data.ProductResults.results) != "undefined"){
			 			for(var i in data.ProductResults.results){
			 				isDataExistrs=true;
			 				var imagePresetSrc = data.ProductResults.results[i].resultThumbnail;
			 				var imgSrc = imagePresetSrc.replace('$Thumbnail$', '$tile-recommendations$');
			 				var imgSrcMob = imagePresetSrc.replace('$Thumbnail$', '$PDP-thumbnail$');
							if (isCloudniaryEnabled()) {
								var imgSrc = imagePresetSrc.replace('$Thumbnail$', '');
								var imgSrcMob = imagePresetSrc.replace('$Thumbnail$', '');
								imgSrc = imgSrc.replace('f_auto,q_auto', 'f_auto,q_auto,t_tile-recommendations');
								imgSrcMob = imgSrc.replace('f_auto,q_auto', 'f_auto,q_auto,t_PDP-thumbnail');
							}
			 				htmlContentProduct = htmlContentProduct+'<div class="col-4 prod-tile-rfl" onclick="location.href=\''+data.ProductResults.results[i].productDisplayUrl+'\'">';
			 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-4-sm text-center" onclick="location.href=\''+data.ProductResults.results[i].productDisplayUrl+'\'">';
			 				htmlContentProduct = htmlContentProduct+'<img class="desktop-only rfk-img-responsive" src="'+imgSrc+'" title="'+data.ProductResults.results[i].ProductName+'">';
			 				htmlContentProduct = htmlContentProduct+'<img class="mobile-only rfk-img-responsive" src="'+imgSrcMob+'" title="'+data.ProductResults.results[i].ProductName+'">';
			 				htmlContentProduct = htmlContentProduct+'</div>';

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-8-sm text-left product-name" onclick="location.href=\''+data.ProductResults.results[i].productDisplayUrl+'\'" >';
			 				htmlContentProduct = htmlContentProduct+'<span class="brand-name" >'+data.ProductResults.results[i].brand+'</span>';
			 				if(data.ProductResults.results[i].ProductName.indexOf(data.ProductResults.results[i].brand) > -1 && 
			 				data.ProductResults.results[i].ProductName.indexOf(data.ProductResults.results[i].brand) == 0){
			 				htmlContentProduct = htmlContentProduct+data.ProductResults.results[i].ProductName.replace(data.ProductResults.results[i].brand,"");
			 				}else{
			 				htmlContentProduct = htmlContentProduct+data.ProductResults.results[i].ProductName;
			 				}
			 				htmlContentProduct = htmlContentProduct+'</br><span class="mobile-only product-pricing">';
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">$'+data.ProductResults.results[i].price+'</span>';
			 				if(typeof(data.ProductResults.results[i].listPrice) != 'undefined' && 
			 						(data.ProductResults.results[i].listPrice*1) > data.ProductResults.results[i].price){
			 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was $'+data.ProductResults.results[i].listPrice+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</span>';
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 				htmlContentProduct = htmlContentProduct+'<div class="col-12  desktop-only  text-center product-pricing" onclick="location.href=\''+data.ProductResults.results[i].productDisplayUrl+'\'">';
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">$'+data.ProductResults.results[i].price+'</span>';
			 				if(typeof(data.ProductResults.results[i].listPrice) != 'undefined' && 
			 						(data.ProductResults.results[i].listPrice*1) > data.ProductResults.results[i].price){
			 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was $'+data.ProductResults.results[i].listPrice+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 			}
			 		}
			 			htmlContentProduct = htmlContentProduct+"</div>";
			 			htmlContentProduct =  htmlContentProduct+"<div class='row desktop-only'>";
			 			htmlContentProduct = htmlContentProduct+'<div class="col-2">&nbsp;</div><div class="col-8 text-center"><a href="javascript:document.CatalogSearchForm.submit()" class="btn btn-primary margin-bottom-sm btn-full" role="button">See All</a></div><div class="col-2"></div></div>';
			 			if(isDataExistrs){

			 							 				$("#productSuggestionResults_div").html(htmlContentProduct);

			 							 			}
			 			var isMobile = window.matchMedia("(max-width: 768px)").matches;
			 			if(!isMobile){
			 				setTimeout(function(){$(".prod-tile-rfl .product-name").dotdotdot();},25);
			 			}

			 				 			 var widthOfWindows = $(window).width()*0.50;
			 			if(($("#SimpleSearchForm_SearchTerm").width()*2) < widthOfWindows){
			 				widthOfWindows = $("#SimpleSearchForm_SearchTerm").width()*2;
			 			}
			 		    var heightOfWIndows = window.innerHeight-$("#header").height();
			 		   if($("#search.search.persist-active.active").length >0){
				 			  heightOfWIndows = heightOfWIndows - $("#search.search.persist-active.active").height();
				 		   }
			 		    if(!isMobile){
			 				if($("#productSuggestionResults_div").height() > $("#infoPart").height()){
			 					$("#infoPart").height($("#productSuggestionResults_div").height());
			 				}else{
			 					$("#productSuggestionResults_div").height($("#infoPart").height());
			 				}
			 				if(($("#infoPart").height()+5) < heightOfWIndows){
			 					heightOfWIndows= $("#infoPart").height()+5;
			 				}
			 			    $("#look-ahead").width(widthOfWindows);
			 			    $("#look-ahead").height(heightOfWIndows);
			 			    $("#look-ahead").css("maxHeight",heightOfWIndows+"px");
			 				if($("#search.search.persist-active.active").length >0){
				 				$("#look-ahead").css("marginLeft","-"+($("#look-ahead").width()-($("#search.search.persist-active.active").width()))+"px");

				 								 			}else{
				 				$("#look-ahead").css("marginLeft","0px");
				 			}
			 				if(isDataExistrs){
			 					$("#look-ahead").addClass("active");
			 				}
			 			}else{
			 				 $("#look-ahead").width($(window).width());
				 			    $("#look-ahead").height((window.innerHeight-($("#header").height()+$("#search").height()))/2);
				 			   $("#look-ahead").css("maxHeight",(window.innerHeight-($("#header").height()+$("#search").height()))/2+"px");
				 				if(isDataExistrs){
				 					$("#look-ahead").addClass("active");
				 				}
			 			}
			 		},
			 		error: function(){
			 			console.log("Autocompleted Errored out.. ");
			 		}
			 	});  
				this.autoSuggestTimer = -1;
			}, this.autoSuggestKeystrokeDelay);
		},

		gotoAdvancedSearch:function(url) {
			var searchTerm = byId("SimpleSearchForm_SearchTerm").value;
			document.location.href = url + '&searchTerm=' + searchTerm;

		},

		showAutoSuggest:function(display) {
			var look_ahead_div = document.getElementById("look-ahead");
				if(display) {
					var showDisplay = display;
					if($('#search').hasClass('persist-active') && !$('#search').hasClass('active')){						
						showDisplay = false;
					}
					if(showDisplay){
						look_ahead_div.classList.add("active");
					}
				}
				else {
					look_ahead_div.classList.remove("active");
			}
		},

		showAutoSuggestIfResults:function() {

			var scrElement = document.getElementById("mobileSearchDropdown");
			if(typeof(staticContent) != "undefined" && document.getElementById(this.STATIC_CONTENT_SECTION_DIV[0]).innerHTML == "" && document.getElementById("autoSuggestHistory").innerHTML == "" && document.getElementById("dynamicAutoSuggestTotalResults") == null) {
				this.showAutoSuggest(false);
			}
			else if(scrElement != null && scrElement.style.display == 'block')
			{
					if(document.getElementById("MobileSimpleSearchForm_SearchTerm").value.length <= this.AUTOSUGGEST_THRESHOLD)
					{
						this.showAutoSuggest(false);
					}
					else
					{
						this.showAutoSuggest(true);
					}
			}
			else {
					if(document.CatalogSearchForm.searchTerm.value.length <= this.AUTOSUGGEST_THRESHOLD)
					{
						this.showAutoSuggest(false);
					}
					else
					{
						this.showAutoSuggest(true);
					}
			}
		},

		selectAutoSuggest:function(term) {
			var scrElement = document.getElementById("mobileSearchDropdown");
			if($('#searchKeyword').size() > 0 && $('#SimpleSearchForm_SearchTerm').size() > 0){
				document.getElementById("searchKeyword").value = document.getElementById("SimpleSearchForm_SearchTerm").value;
			}
			if (scrElement != null && scrElement.style.display == 'block'){
				var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
			}else{
				var searchBox = document.CatalogSearchForm.searchTerm;
			}

			searchBox.value = term;
			searchBox.focus();
			this.autoSuggestPreviousTerm = term;
			document.getElementById("look-ahead").classList.remove("active");
			if(typeof(cmCreateElementTag) == 'function'){
				cmCreateElementTag('SearchSuggest', term);
			}

							var promoJSON = {"promo_name" : "SearchSuggest", "promo_location" : term, "promo_desccrption" : "Location"};

						try{
				var omnitureEnabled
				if(dojo.byId("omnitureEnabled") != undefined && dojo.byId("omnitureEnabled") != null)
					omnitureEnabled = dojo.byId("omnitureEnabled").value;

								if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
					var searchEventDetails = {};
					searchEventDetails["event_search_suggestion"] = "yes";
					searchEventDetails["searchsuggestion_keyword"] = term;	
					searchEventDetails["event_name"] = "search_suggestion_added";
					pushEvent(searchEventDetails);
				}
			}catch(err){
				console.log("issue in tagging "+err);
			}

					dojo.place("<input type='hidden' value='SearchSuggest-_-"+term+"-_-Location' name='cm_sp' />", document.CatalogSearchForm);
			dojo.place("<input type='hidden' value='"+term+"' name='searchsuggestion_keyword' />", document.CatalogSearchForm);
			submitSpecifiedForm(document.CatalogSearchForm);
		},

		highLightSelection:function(state, index) {
			var selection = document.getElementById("autoSelectOption_" + index);
			if(selection != null && selection != 'undefined') {

				if(state) {
					if(document.getElementById('category_list_' + index) != null && document.getElementById('category_list_' + index) != undefined)
						document.getElementById('category_list_' + index).style.backgroundColor = "#d9e9f7";
					if(document.getElementById('autoSelectOption_' + index) != null && document.getElementById('autoSelectOption_' + index) != undefined)
						document.getElementById('autoSelectOption_' + index).style.backgroundColor = "#d9e9f7";
					var scrElement = document.getElementById("mobileSearchDropdown");
					if (scrElement != null && scrElement.style.display == 'block'){
						var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
					}else{
						var searchBox = document.CatalogSearchForm.searchTerm;
					}
					searchBox.setAttribute("aria-activedescendant", "suggestionItem_" + index);
					var totalDynamicResults = document.getElementById("dynamicAutoSuggestTotalResults");
					if((totalDynamicResults != null && totalDynamicResults != 'undefined' && index < totalDynamicResults.value) || (index >= this.historyIndex)) {
						searchBox.value = selection.title;
						this.autoSuggestPreviousTerm = selection.title;
						this.autoSuggestURL = "";
					}
					else {
						this.autoSuggestURL = selection.href;
					}
				}
				else {
					if(document.getElementById('category_list_' + index) != null && document.getElementById('category_list_' + index) != undefined)
						$("#category_list_" + index).css("background-color", "");
					if(document.getElementById('autoSelectOption_' + index) != null && document.getElementById('autoSelectOption_' + index) != undefined)
						$("#autoSelectOption_" + index).css("background-color", "");
				}
				return true;
			}
			else {
				return false;
			}
		},

		enableAutoSelect:function(index) {
			this.highLightSelection(false, this.autoSelectOption);
			if(document.getElementById('category_list_' + index) != null && document.getElementById('category_list_' + index) != undefined)
				document.getElementById('category_list_' + index).style.backgroundColor = "#d9e9f7";
			if(document.getElementById('autoSelectOption_' + index) != null && document.getElementById('autoSelectOption_' + index) != undefined)
				document.getElementById('autoSelectOption_' + index).style.backgroundColor = "#d9e9f7";
			this.autoSelectOption = index;

					},

		disableHighlight:function(index){
			if(document.getElementById('category_list_' + index) != null && document.getElementById('category_list_' + index) != undefined)
					$("#category_list_" + index).css("background-color", "");
			if(document.getElementById('autoSelectOption_' + index) != null && document.getElementById('autoSelectOption_' + index) != undefined)
				$("#autoSelectOption_" + index).css("background-color", "");
		},

				resetAutoSuggestKeyword:function() {
			var originalKeyedSearchTerm = document.getElementById("autoSuggestOriginalTerm");
			if(originalKeyedSearchTerm != null && originalKeyedSearchTerm != 'undefined') {
				var scrElement = document.getElementById("mobileSearchDropdown");
				if (scrElement != null && scrElement.style.display == 'block')
				{
					var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
				}else{
					var searchBox = document.CatalogSearchForm.searchTerm;
				}
				searchBox.value = originalKeyedSearchTerm.value;
				this.autoSuggestPreviousTerm = originalKeyedSearchTerm.value;
			}
		},


		clearAutoSuggestResults:function() {
			if(typeof(staticContent) != "undefined") {
				for (var i = 0; i < staticContent.length; i++) {
					document.getElementById(this.STATIC_CONTENT_SECTION_DIV[i]).innerHTML = "";
				}
			}
			this.autoSuggestPreviousTerm = "";
			this.autoSuggestURL = "";
			document.getElementById("searchSuggestionResults_div").innerHTML = "";
			document.getElementById("productSuggestionResults_div").innerHTML = "";
			this.showAutoSuggest(false);
		},

		doAutoSuggest:function(event, url, searchTerm) {
			if(searchTerm.length <= this.AUTOSUGGEST_THRESHOLD ) {
				this.showAutoSuggest(false);
			}

			if(event.keyCode == dojo.keys.ENTER) {
				this._handleEnterKey();
				return;
			}

			if(event.keyCode == dojo.keys.TAB) {
				this.autoSuggestHover = true;
				return;
			}

			if(event.keyCode == dojo.keys.ESCAPE) {
				this.showAutoSuggest(false);
				return;
			}

			if(event.keyCode == dojo.keys.UP_ARROW) {
				var totalDynamicResults = document.getElementById("dynamicAutoSuggestTotalResults");
				if(this.END_OF_LIST) {
					this.END_OF_LIST = false;
					this.autoSelectOption--;
					if(!this.highLightSelection(true, this.autoSelectOption)) {
						if(this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET && totalDynamicResults != null && totalDynamicResults != 'undefined') {
							this.autoSelectOption = totalDynamicResults.value-1;
							this.highLightSelection(true, this.autoSelectOption);
						}
					}
				}
				else if (this.highLightSelection(true, this.autoSelectOption-1)) {
					this.highLightSelection(false, this.autoSelectOption);
					if(this.autoSelectOption == this.historyIndex) {
						this.resetAutoSuggestKeyword();
					}
					this.autoSelectOption--;
				}
				else if(this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET && totalDynamicResults != null && totalDynamicResults != 'undefined') {
					this.highLightSelection(false, this.CACHED_AUTOSUGGEST_OFFSET);
					this.autoSelectOption = totalDynamicResults.value-1;
					this.highLightSelection(true, this.autoSelectOption);
				}
				else {
					this.highLightSelection(false, this.autoSelectOption);
					this.autoSelectOption = -1;
					var originalKeyedSearchTerm = document.getElementById("autoSuggestOriginalTerm");
					this.resetAutoSuggestKeyword();
				}
				return;
			}

			if(event.keyCode == dojo.keys.DOWN_ARROW) {
				if(this.highLightSelection(true, this.autoSelectOption+1)) {
					this.highLightSelection(false, this.autoSelectOption);
					this.autoSelectOption++;
				}
				else if(this.autoSelectOption < this.CACHED_AUTOSUGGEST_OFFSET && this.highLightSelection(true, this.CACHED_AUTOSUGGEST_OFFSET)) {
					this.highLightSelection(false, this.autoSelectOption);
					this.autoSelectOption = this.CACHED_AUTOSUGGEST_OFFSET;
					this.resetAutoSuggestKeyword();
				}
				else if(!this.END_OF_LIST) {
					this.highLightSelection(false, this.autoSelectOption);
					this.autoSelectOption++;
					this.END_OF_LIST = true;
					var scrElement = document.getElementById("mobileSearchDropdown");
					if (scrElement != null && scrElement.style.display == 'block'){
						var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
					}else{
						var searchBox = document.CatalogSearchForm.searchTerm;
					}
				}
				return;
			}

			if(searchTerm.length > this.AUTOSUGGEST_THRESHOLD && searchTerm == this.autoSuggestPreviousTerm) {
				return;
			}
			else {
				this.autoSuggestPreviousTerm = searchTerm;
			}

			if(searchTerm.length <= this.AUTOSUGGEST_THRESHOLD) {
				return;
			};

			if(this.autoSuggestTimer != -1) {
				clearTimeout(this.autoSuggestTimer);
				this.autoSuggestTimer = -1;
			}

			if(searchTerm != "") {
				this.autoSelectOption = -1;
				var hasResults = this.doStaticAutoSuggest(searchTerm);
				if(searchTerm.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
					var showHeader = true; 
					this.doDynamicAutoSuggest(url, searchTerm, showHeader);
				}
				else {


															document.getElementById("searchSuggestionResults_div").innerHTML = "";
					document.getElementById("productSuggestionResults_div").innerHTML = "";
				}
			}
			else {
				this.clearAutoSuggestResults();
			}
		},

		tokenizeForBidi:function(displayName, searchName, searchTerm, searchTermLower,listCount) {
			var tokens = displayName.split( " > " );
			var html = "";
			var str = "";
			if(tokens.length > 0) {
				html = html + "<div class='category_list' id='category_list_"+listCount+"'>";
				for(i = 0; i < tokens.length; i++) {
					if(i!=0) {
						html = html + "<span class='gt'>&nbsp; > &nbsp;</span>";
					}
					if(i == tokens.length - 1) {
						var index = searchName.toLowerCase().indexOf(searchTermLower);
						var subStringBefore = searchName.substr(0, index);
						var subStringAfter =  searchName.substr(index + searchTerm.length);
						var highLighted = "<span class='highlight'><strong>" + searchTerm + "</strong></span>";
						str = subStringBefore + highLighted + subStringAfter;
					}
					else {
						str = tokens[i];
					}
					html = html + str;
				}
				html = html + "</div>";
			}
			return html;
		},

		doStaticAutoSuggest:function(searchTerm) {
			var resultList = ["", "", "", "", "", ""];
			var emptyCell = 0;
			var searchTermLower = searchTerm.toLowerCase();
			var listCount = this.CACHED_AUTOSUGGEST_OFFSET;
			var divStart = "<div class='list_section'><div";
			var divEnd =   "</div></div>";

						if(typeof(staticContent) != "undefined") {
			for(var i = 0; i < staticContent.length; i++) {
				var count = 0;
				var suggestionType = staticContentHeaders[i].split(' ')[0];
				resultList[i] += "<ul class='list-unstyled'>";
				for(var j = 0; j < staticContent[i].length; j++) {
					var searchName = staticContent[i][j][0];
					var searchURL = staticContent[i][j][1];
					var displayName = staticContent[i][j][2];
					var index = searchName.toLowerCase().indexOf(searchTermLower);
					if(index != -1) {
						var htmlDisplayName = this.tokenizeForBidi(displayName, searchName, searchTerm, searchTermLower,listCount);

						resultList[i] += "<li id='suggestionItem_" + listCount + "' role='listitem' tabindex='-1'><a id='autoSelectOption_" + listCount + "' title='" + searchName + "' onmouseout='SearchJS.disableHighlight(" + listCount + "); this.autoSuggestURL=\"\";' onclick='SearchJS.hideSearchComponent();' onmouseover='SearchJS.enableAutoSelect(&quot;" + listCount + "&quot;); this.autoSuggestURL=this.href;' manual_cm_sp='SearchSuggestion-_-"+suggestionType+"Category_"+listCount+"-_-"+((htmlDisplayName.split(" ").join("")).split('"').join('')).split("'").join("")+"' href=\"" + searchURL + "\">" + htmlDisplayName + "</a></li>";
						count++;
						listCount++;
						if(count >= this.TOTAL_SUGGESTED) {
							break;
						}
					}
				}
				resultList[i] += "</ul>";
			}			

			for (var i = 0; i < staticContent.length; i++) {
				document.getElementById(this.STATIC_CONTENT_SECTION_DIV[i]).innerHTML = "";
				if(resultList[i] != "<ul class='list-unstyled'></ul>") {
					var heading =  "<div class='look-ahead-categories'>" + staticContentHeaders[i] ;
					document.getElementById(this.STATIC_CONTENT_SECTION_DIV[emptyCell]).innerHTML = heading + divStart + " role='list' title='" + staticContentHeaders[i] + "' aria-label='" + staticContentHeaders[i] + "'>" + resultList[i] + divEnd;
					emptyCell++;
				}
			}
		}

			var historyList = "";
			var searchHistorySection = document.getElementById("autoSuggestHistory");
			searchHistorySection.innerHTML = "";
			var historyArray = new Array();
			this.historyIndex = listCount;

			var searchHistoryCookie = getCookie("searchTermHistory");



			if(emptyCell > 0) {
				this.showAutoSuggest(true);
				return true;
			}

			return false;
		},

		retrieveCachedSuggestions:function() {
			if(!this.retrievedCachedSuggestions) {
				wc.render.getRefreshControllerById("AutoSuggestCachedSuggestionsController").url = this.CachedSuggestionsURL;
				console.debug("update cache sugg "+this.CachedSuggestionsURL);
				wc.render.updateContext("CachedSuggestions_Context", {});
			}
		},

		updateSearchTermHistoryCookie:function(updatedSearchTerm){
			var cookieKey = "searchTermHistory";
			var cookieValue = "|" + updatedSearchTerm;
			var searchTermHistoryCookie = getCookie(cookieKey);
			if(typeof(searchTermHistoryCookie) != 'undefined') {
				cookieValue =  dojo.cookie(cookieKey) + cookieValue;
			}
			dojo.cookie(cookieKey, cookieValue, {path:'/'});
		},

		updateSearchTermHistoryCookieAndRedirect:function(updatedSearchTerm, redirectURL){
			this.updateSearchTermHistoryCookie(updatedSearchTerm);
			document.location.href = redirectURL;
		},

		isValidNumber:function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n) && n >= 0;
		},

		validateForm: function(form) {
			form["minPrice"].value = trim(form["minPrice"].value);
			form["maxPrice"].value = trim(form["maxPrice"].value);

			var minValue = form["minPrice"].value;
			var maxValue = form["maxPrice"].value;

			var minIsValid = this.isValidNumber(minValue);
			var maxIsValid = this.isValidNumber(maxValue);

			if(minValue.length > 0 && !minIsValid) {
				MessageHelper.formErrorHandleClient(form["minPrice"].id, MessageHelper.messages["EDPPaymentMethods_AMOUNT_NAN"]);
				return false;
			}
			else if(maxValue.length > 0 && !maxIsValid) {
				MessageHelper.formErrorHandleClient(form["maxPrice"].id, MessageHelper.messages["EDPPaymentMethods_AMOUNT_NAN"]);
				return false;
			}
			else if (minValue.length > 0 && maxValue.length > 0 && parseFloat(minValue) > parseFloat(maxValue)) {
				MessageHelper.formErrorHandleClient(form["maxPrice"].id, MessageHelper.messages["ERROR_PRICE_RANGE"]);
				return false;
			}

						form["searchTerm"].value = trim(form["searchTerm"].value);
			form["filterTerm"].value = trim(form["filterTerm"].value);
			form["manufacturer"].value = trim(form["manufacturer"].value);

						var searchTerm = form["searchTerm"].value;
			var filterTerm = form["filterTerm"].value;
			var manufacturer = form["manufacturer"].value;

						if (searchTerm.length == 0 && filterTerm.length == 0 && manufacturer.length == 0) {
				MessageHelper.formErrorHandleClient(form["searchTerm"].id, MessageHelper.messages["ERROR_EMPTY_SEARCH_FIELDS"]);
				return false;
			}

						form.submit();
		},
		removeCOmmaAndSubmit:function(){
			var searchTerm = $("#SimpleSearchForm_SearchTerm");
			var searchButton = $('#submitButton');	
			if(searchTerm.val().length > 0 ){
				searchButton.addClass('active');
				var searchTermVal = searchTerm.val();
				searchTerm.val(searchTermVal.split("’").join("'"));
				if(searchTermVal.indexOf(",")>-1 && searchTermVal.split(",").length > 2 ){
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.split(",").join("");
					searchTermVal = searchTermVal.split("<<COMMA>>").join(",");
					searchTerm.val(searchTermVal);
				}
			} else {
				searchButton.removeClass('active');
			}
		}

	};

	wc.render.declareContext("AutoSuggest_Context",null,"");

	wc.render.declareContext("CachedSuggestions_Context",null,"");

	wc.render.declareRefreshController({
	   id: "AutoSuggestCachedSuggestionsController",
	   renderContext: wc.render.getContextById("CachedSuggestions_Context"),
	   url: "",
	   formId: ""

	   ,renderContextChangedHandler: function(message, widget) {
			  var controller = this;
			  var renderContext = this.renderContext;
			  widget.refresh(renderContext.properties);
	   }

	   ,postRefreshHandler: function(widget) {
			  var controller = this;
			  var renderContext = this.renderContext;
			  var response = document.getElementById('cachedSuggestions');
			  if(response == null) {
				      var obj = document.getElementById("autoSuggestCachedSuggestions_div");
				      if (obj != null) {
				    	  document.getElementById("autoSuggestCachedSuggestions_div").innerHTML = "";
				      }
			  }
			  else {
					 var scripts = response.getElementsByTagName("script");
					 var j = scripts.length;
					 for (var i = 0; i < j; i++){
							var newScript = document.createElement('script');
							newScript.type = "text/javascript";
							newScript.text = scripts[i].text;
							document.getElementById('autoSuggestCachedSuggestions_div').appendChild (newScript);
					 }
					 SearchJS.retrievedCachedSuggestions = true;
					 var scrElement = document.getElementById("mobileSearchDropdown");
					 if (scrElement != null && scrElement.style.display == 'block')
					 {
						 searchTerm = document.getElementById("MobileSimpleSearchForm_SearchTerm").value;
					 }
					 else
					 {
						 searchTerm = document.CatalogSearchForm.searchTerm.value;
					 }
					 if(searchTerm.length > SearchJS.AUTOSUGGEST_THRESHOLD) {
							SearchJS.doStaticAutoSuggest(searchTerm);
					 }
			  }
	   }
	});

	wc.render.declareRefreshController({
		   id: "AutoSuggestDisplayController",
		   renderContext: wc.render.getContextById("AutoSuggest_Context"),
		   url: "",
		   formId: ""

		   ,renderContextChangedHandler: function(message, widget) {
				  var controller = this;
				  var renderContext = this.renderContext;
				  widget.refresh(renderContext.properties);
		   }

		   ,postRefreshHandler: function(widget) {
				  var controller = this;
				  var renderContext = this.renderContext;
				  var response = document.getElementById('suggestedKeywordResults');
				  if(response == null) {
					document.getElementById("autoSuggestDynamic_Result_div").innerHTML = "";
				  }
				  SearchJS.showAutoSuggestIfResults();
		   }
	});
	var searchedItem = "";
	wc.render.declareContext("petcoSearchBox_Context",null,"");
	wc.render.declareRefreshController({
	   id: "petcoSearchBoxController",
	   renderContext: wc.render.getContextById("petcoSearchBox_Context"),
	   url: "",
	   formId: ""
	   ,renderContextChangedHandler: function(message, widget) {
			  var controller = this;
			  var renderContext = this.renderContext;
			  searchedItem = $("#SimpleSearchForm_SearchTerm").val();
			  widget.refresh(renderContext.properties);
	   }
	   ,postRefreshHandler: function(widget) {
		   if(searchedItem != ""){
				 $("#SimpleSearchForm_SearchTerm").val(searchedItem);
				 $("#SimpleSearchForm_SearchTerm").focus();
			 }

			 eval($("#rfl-srch-javascript").html());
	   }
	});
}